import axios from "axios";
import { SwaggerJsonFile } from "models/apiDocumentation/apiDocumentationModels";

export const getSwaggerJsonFile = async (): Promise<SwaggerJsonFile> => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_SWAGGER_FILE}`,
    {
      responseType: "json",
    }
  );
  return response.data;
};

export const getNoSqlSwaggerJsonFile =
  async (): Promise<SwaggerJsonFile | null> => {
    const response = await axios.get(
      `${process.env.REACT_APP_NOSQL_API_SWAGGER_FILE}`,
      {
        responseType: "json",
      }
    );
    return response.data;
  };
